import { R_SIGNON, authDebug, authError, startSignon } from 'app/Auth/lib'

export function doSignOnLocal({
  signup,
  handle,
  password,
  state,
  status,
  dispatch
}) {
  authDebug('[Signon].doSignOnLocal()', '')

  dispatch({ type: R_SIGNON.SIGNING_IN })

  const vars = {
    signup,
    factor: 'email', // in the future: let people choose factors to auth with
    handle,
    password,
    email: signup ? handle : ''
  }

  if (vars.handle.length === 0) {
    authError({ dispatch, msg: 'Please provide an email address!' })
    return Promise.resolve({ aborted: true })
  }
  if (vars.password.length === 0) {
    authError({ dispatch, msg: 'Please provide a password!' })
    return Promise.resolve({ aborted: true })
  }

  return startSignon({ state, status, vars, dispatch })
}
